import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { MotivoPerda } from '../models/motivo-perda';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { MotivoPerdaService } from '../services/motivo-perda.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';
import { GrupoMotivoPerda } from '../models/grupo-motivo-perda';
import { GrupoMotivoPerdaService } from '../services/grupo-motivo-perda.service';

@Component({
  selector: 'app-motivo-perda-orc',
  templateUrl: './motivo-perda-orc.component.html',
  styleUrls: ['./motivo-perda-orc.component.scss']
})
export class MotivoPerdaOrcComponent implements OnInit {

  // variáveis
  motivosPerda: MotivoPerda[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  grupos: GrupoMotivoPerda[] = [];
  grupoSelecionado;

 @ViewChild('paginator', { static: false }) paginator: MatPaginator;

 // construtor
 constructor(private motivoPerdaService: MotivoPerdaService, private utilitarioService: UtilitarioService,
   private router: Router, private globalService: GlobalService, private carregandoService: CarregandoService,
   private notificacaoService: NotificacaoService, private route: ActivatedRoute, private paginatorService: PaginatorService,
   private gruposMotivoPerdaService: GrupoMotivoPerdaService) { }

 ngOnInit() {
  const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

   this.buscaMotivosOrcamento();
   this.buscarGruposMotivoPerda();
 }

 compare(a: number | string, b: number | string, isAsc: boolean) {
   if (typeof a === 'string') {
     a = a.toLowerCase();
   }

   if (typeof b === 'string') {
     b = b.toLowerCase();
   }

   return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
 }

 buscaMotivosOrcamento() {
  this.carregandoService.mostra('buscarStatusOrcamento');
  this.carregando = true;

  this.motivoPerdaService.consultarComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
    this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.grupoSelecionado).subscribe((data: any) => {
      this.paginator.firstPage();
      this.motivosPerda = data.itens;
      this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(data.total);

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarStatusOrcamento');

    }, (erro) => {
      this.carregandoService.esconde('buscarStatusOrcamento');
      this.notificacaoService.erro(erro);
    });
}

buscarGruposMotivoPerda() {
  this.carregandoService.mostra('buscaGrupos');
  this.gruposMotivoPerdaService.buscarTodos().subscribe(data => {
    this.grupos = data;
    this.carregandoService.esconde('buscaGrupos');
  }, (erro) => {
    this.notificacaoService.erro('Não foi possível buscar os grupos');
    this.carregandoService.esconde('buscaGrupos');
  });
}

 novo() {
   this.router.navigate(['novo'], { relativeTo: this.route });
 }

 editar(motivoPerda: MotivoPerda) {
   this.router.navigate(['editar', motivoPerda.id], { relativeTo: this.route });
 }

 excluir(motivoPerda: MotivoPerda) {
   swal({
     title: 'Atenção!!',
     text: 'Deseja realmente excluir o Motivo de Perda de Orçamento?',
     type: 'warning',
     showCancelButton: true,
     confirmButtonClass: 'btn btn-info',
     cancelButtonClass: 'btn btn-danger',
     confirmButtonText: 'Sim',
     cancelButtonText: 'Não',
     buttonsStyling: false
   }).then((result) => {
     if (result.value) {
       this.carregandoService.mostra('excluiOrcStatus');
       this.motivoPerdaService.excluir(motivoPerda.id).subscribe(resp => {
         this.notificacaoService.sucesso('Status de Orçamento excluído com sucesso!!!');
         this.carregandoService.esconde('excluiOrcStatus');
         this.buscaMotivosOrcamento();
       }, (erro) => {
         this.carregandoService.esconde('excluiOrcStatus');
         this.notificacaoService.erro(erro);
       });
     }
   });
 }

 mudaDePagina(pageEvent: PageEvent) {
  this.itensPorPagina = pageEvent.pageSize;
  this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

  this.buscaMotivosOrcamento();
}

ordena(campo) {
  if (campo) {
    this.campoOrdenacao = campo;
    this.ordenarDesc = !this.ordenarDesc;

    this.motivosPerda = this.motivosPerda.sort((a, b) => {
      const isAsc = !this.ordenarDesc;

      switch (this.campoOrdenacao) {
        case 'descricao': return this.compare(a.descricao, b.descricao, isAsc);
        default: return 0;
      }
    });

    this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
  }

  return false;
}

filtra() {
  this.buscaMotivosOrcamento();
  this.paginator.firstPage();
}

 ngOnDestroy(): void { }

}
